import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@freyr/freya-design-system/dist/src/css/freyads.min.css";
import './assets/scss/main.scss';
import { LicenseInfo } from "@mui/x-license-pro";
LicenseInfo.setLicenseKey("3ca440339979337160406e3219059976Tz03OTAwNCxFPTE3MzE5MzM3OTgwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y");
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
